module.exports = __webpack_public_path__ + "assets/img/101104.13760972.png";